import React from "react";
import { Col, Layout, Row } from "antd";

const { Header, Content } = Layout;

interface AppLayoutProps {
  children?: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {

  return (
    <Layout style={{ minHeight: "100vh", overflow: "hidden" }}>
      <Layout
        className="site-layout"
        style={{
          transition: "margin-left 0.3s ease",
        }}
      >
        <Header
          style={{
            background: "#114373",
            padding: 0,
            position: "fixed",
            height: "70px",
            width: "100%",
            zIndex: 1100,
          }}
          className="site-layout-background"
        >
          <Row justify="space-between" align="middle" style={{height: "100%"}}>
            <Col >
              <div className="logo">
                <img
                  src="/logo_algolabs.png"
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    marginLeft: "10px",
                  }}
                  alt="Logo"
                />
              </div>
            </Col>
            <Col>
              <div className="logo">
                <img
                  src="/login_logo.png"
                  style={{
                    maxHeight: "90%",
                    maxWidth: "90%",
                    marginRight: "10px",
                  }}
                  alt="Logo"
                />
              </div>
            </Col>
          </Row>
        </Header>
        <Content
          className="content"
          style={{
            padding: "64px 0px 0px",
            minHeight: "100vh",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
